export const getWindowScreen = (): { availHeight: number; availWidth: number } => window.screen;
